// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"nWESnsGO"};